import { render } from "./App.vue?vue&type=template&id=c5c1ed88"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c5c1ed88&lang=css"

import exportComponent from "F:\\SUPERChat\\SuperBot-ChatGPTApp\\SUPER_WEB\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@17.1.1_@vue+compiler-sfc@3.3.4_vue@3.2.13_webpack@5.84.1\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__